/**
 * @file With this file we are trying to decouple `usePricedProducts.ts` into
 * smaller single-focused pure functions, making it much easier to read and
 * refactor later.
 * It's important to add ONLY PURE FUNCTIONS on this file.
 */
import { ColorModel, CornerInfo, DiagonalCornerModel, MaterialModel, ProductQty } from '@common/models';

/**
 * Return a ProductQty record for a corner.
 * For Diagonal Corners, only return if it's an inside diagonal.
 * For Radius Corners, override the productId if given a cornerProductIdBySize
 * @param cornerInfo corner object in `DrawingShape.cornerMap`
 * @param diagonalProduct inside diagonal corner product from the `/diagonal-corner` API
 * @param cornerProductIdBySize the found corner product matching the size THIS IS PREFERRED
 */
export function getProductQtyFromCornerInfo(
    cornerInfo: CornerInfo,
    diagonalProduct: DiagonalCornerModel | undefined,
    cornerProductIdBySize: number | undefined
): ProductQty | null {
    if (cornerInfo.diagonalLength) {
        return diagonalProduct
            ? {
                  productId: diagonalProduct.productId,
                  quantity: 1,
              }
            : null;
    }
    // realistically, if cornerInfo.productId should be ignored
    const cornerProductId = cornerProductIdBySize ?? cornerInfo.productId;
    return cornerProductId
        ? {
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              productId: cornerProductId,
              quantity: 1,
          }
        : null;
}

export const areProductsReadyToQuery = (material: MaterialModel, color?: ColorModel): boolean =>
    !!(material && color?.productId);
